import ApiService from './api.service'
const main = '/vacancy'

const NationalityService = {
    getList: async function (data) {
        return ApiService.post(`${main}/nationality-list`, data)
    }
}

export default NationalityService;
